// All sections that can have permissions
export const ALL_SECTIONS = [
  { id: 'tasks', label: 'Tasks' },
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'dailylog', label: 'Daily Log' },
  { id: 'sales', label: 'Daily Sales' },
  { id: 'waste', label: 'Waste Log' },
  { id: 'purchases', label: 'Purchases' },
  { id: 'otherexpenses', label: 'Other Expenses' },
  { id: 'recordsale', label: 'Record Sale' },
  { id: 'pricesheet', label: 'Price Sheet' },
  { id: 'costcards', label: 'Cost Cards' },
  { id: 'batches', label: 'Batches' },
  { id: 'inventory', label: 'Inventory' },
  { id: 'orderguide', label: 'Order Guide' },
  { id: 'weeklyreport', label: 'Weekly Report' },
  { id: 'fixed', label: 'Fixed Costs' },
  { id: 'reports', label: 'Reports' },
  { id: 'settings', label: 'Settings' },
  { id: 'monthlypl', label: 'Back Office — Monthly P&L' },
  { id: 'expensetracker', label: 'Back Office — Expense Tracker' },
  { id: 'pricetrends', label: 'Back Office — Price Trends' },
  { id: 'activitylog', label: 'Back Office — Activity Log' },
  { id: 'swappedinvoices', label: 'Back Office — Swapped Invoices' },
  { id: 'prepaid', label: 'Back Office — Prepaid' },
];

// Default permissions for new members
export const DEFAULT_PERMS = {
  tasks: { can_view: true, can_edit: true },
  dashboard: { can_view: true, can_edit: false },
  sales: { can_view: true, can_edit: true },
  waste: { can_view: true, can_edit: true },
  purchases: { can_view: true, can_edit: true },
};

// Default permissions for new admins
export const ADMIN_PERMS = {
  tasks: { can_view: true, can_edit: true },
  dashboard: { can_view: true, can_edit: true },
  dailylog: { can_view: true, can_edit: true },
  sales: { can_view: true, can_edit: true },
  waste: { can_view: true, can_edit: true },
  purchases: { can_view: true, can_edit: true },
  otherexpenses: { can_view: true, can_edit: true },
  pricesheet: { can_view: true, can_edit: true },
  costcards: { can_view: true, can_edit: true },
  batches: { can_view: true, can_edit: true },
  inventory: { can_view: true, can_edit: true },
  orderguide: { can_view: true, can_edit: true },
  weeklyreport: { can_view: true, can_edit: true },
  reports: { can_view: true, can_edit: true },
  settings: { can_view: true, can_edit: true },
};

// Check if user can view a section
export function canView(perms, section, userRole) {
  if (userRole === 'owner') return true;
  return perms?.[section]?.can_view || false;
}

// Check if user can edit a section
export function canEdit(perms, section, userRole) {
  if (userRole === 'owner') return true;
  return perms?.[section]?.can_edit || false;
}
